export default __webpack_public_path__ + "static/media/cheque-layout-1x.e4913fcc.png";